import { Icon, type IconName } from "@uigovpe/components";

type MetricCardProps = { title: string; value: number; icon: IconName };

export function MetricCard({ title, value, icon }: MetricCardProps) {
  return (
    <div className="flex! min-h-[105px]! w-full! min-w-0! flex-col! justify-center! gap-2! rounded-xl! border-l-[6px]! border-l-[#5a3b86]! bg-white! px-6! py-5! shadow-xl!">
      <span className="flex! size-6! shrink-0! items-center! justify-center! rounded-md! bg-[#5a3b86]! text-white!">
        <Icon icon={icon} outline className="text-[15px]! leading-none!" />
      </span>
      <div className="flex! flex-col! gap-1!">
        <strong className="break-words! text-sm! font-medium! text-[#4e3873]!">
          {title}
        </strong>
        <span className="text-xl! font-medium! text-zinc-900!">{value}</span>
      </div>
    </div>
  );
}
